const emailRegex = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
const phoneRegex = /^(\+91-|\+91|0)?\d{10}$/;
const specialCharacters = /[ˆa-zA-Z0-9]/gi;
const isValidEmail = (value) => emailRegex.test(value);
const isValidPhone = (value) => phoneRegex.test(value);
const removeSpecialCharacters = (value, exclude = '') => {
    let regex = specialCharacters;
    if (exclude) {
        try {
            regex = new RegExp(`[^a-zA-Z0-9${exclude}]`, 'gi');
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
    }
    return value.replace(regex, '');
};
export { isValidEmail, isValidPhone, removeSpecialCharacters };
